/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./globalPartyList.vue?vue&type=template&id=680b22e2&scoped=true&"
import script from "./globalPartyList.vue?vue&type=script&lang=js&"
export * from "./globalPartyList.vue?vue&type=script&lang=js&"
import style0 from "./globalPartyList.vue?vue&type=style&index=0&id=680b22e2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680b22e2",
  null
  
)

export default component.exports